import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ServiceResourceMapping } from '../../types/service';
import { v4 as uuidv4 } from 'uuid';

const initialState: ServiceResourceMappingState = {
  items: [],
  isLoading: false,
  error: null,
};

const serviceResourceMappingSlice = createSlice({
  name: 'serviceResourceMappings',
  initialState,
  reducers: {
    addMapping: (state, action: PayloadAction<Omit<ServiceResourceMapping, 'id'>>) => {
      const newMapping = { ...action.payload, id: uuidv4() };
      state.items.push(newMapping);
    },
    deleteMapping: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(item => item.id !== action.payload);
    },
    deleteMappingsByService: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(item => item.serviceId !== action.payload);
    },
  },
});

export const { addMapping, deleteMapping, deleteMappingsByService } =
  serviceResourceMappingSlice.actions;
export default serviceResourceMappingSlice.reducer;
